import type { Dispatch, SetStateAction } from 'react';

import dayjs from 'dayjs';
import { DateInput, FieldLabel } from 'design-system';

import { useUserConfig } from '@/features/_shared/user';
import { clock } from '@/services/clock';

const AbsoluteSelector = ({
  comparisonDate,
  setComparisonDate,
  comparisonType,
  startPoint
}: {
  comparisonDate: Date | null;
  setComparisonDate: Dispatch<SetStateAction<Date | null>>;
  comparisonType: string;
  startPoint: number | undefined;
}) => {
  const { data: userConfigData } = useUserConfig();
  const dateFormat = (userConfigData?.dateFormat.value ?? 'dd-MMM-yy').toUpperCase();
  const fakeToday = startPoint ? new Date(startPoint) : clock.date();

  return (
    <div className='flex flex-col gap-1 pl-6'>
      <FieldLabel htmlFor='comparison-date'>Comparison date</FieldLabel>
      <DateInput
        id='comparison-date'
        aria-label='Comparison date'
        className='w-full'
        defaultMonth={fakeToday}
        disabled={comparisonType !== 'absolute'}
        disabledDates={[{ after: fakeToday }, { dayOfWeek: [0, 6] }]}
        formatDate={date => dayjs(date).format(dateFormat)}
        placeholder={dateFormat}
        value={comparisonDate ?? undefined}
        onValueChange={value => {
          setComparisonDate(value ?? null);
        }}
      />
      <p className='text-sm text-muted-foreground'>Select one of the available data points</p>
    </div>
  );
};
export default AbsoluteSelector;
